import React from 'react';
import Aboutme from './Aboutme';
import PortBanner from './PortBanner';
import Projects from './Projects';

const MyPortfolio = () => {
    return (
        <div>
            <PortBanner/>
            <Aboutme/>
            <Projects/>
        </div>
    );
};

export default MyPortfolio;